export default function createBass(audioContext) {
    const highpassFilter = audioContext.createBiquadFilter();
    highpassFilter.type = 'highpass';
    highpassFilter.frequency.value = 30;
    highpassFilter.connect(audioContext.destination);

    const lowpassFilter = audioContext.createBiquadFilter();
    lowpassFilter.type = 'lowpass';
    lowpassFilter.frequency.value = 1000; // make this higher?
    lowpassFilter.connect(highpassFilter); // this needs to go through the other filter

    const gain = audioContext.createGain();
    gain.gain.value = 0.0001;
    gain.connect(lowpassFilter);

    return {
        play(time, pitch) {
            const subOsc = audioContext.createOscillator();
            subOsc.connect(gain);
            subOsc.frequency.value = pitch;
            subOsc.type = 'sine';

            const triangleOsc = audioContext.createOscillator();
            triangleOsc.connect(gain);
            triangleOsc.frequency.value = pitch;
            triangleOsc.type = 'triangle';

            gain.gain.setValueAtTime(0.0001, time);
            gain.gain.exponentialRampToValueAtTime(0.3, time + 0.3);

            subOsc.start(time);
            subOsc.stop(time + 0.5);
            triangleOsc.start(time);
            triangleOsc.stop(time + 0.5);
        }
    }
}



// WEBPACK FOOTER //
// ./src/instruments/createBass.js